import {Box, Tab, Tabs, useMediaQuery, useTheme} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {
                value === index && (
                    <Box sx={{ pt: 5 }}>
                        {children}
                    </Box>
                )
            }
        </div>
    );
}

const TabsComponent = ({
    list,
    manualIndex=0,
    customChangeFunction=null
}) => {
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [value, setValue] = useState(manualIndex);

    const handleChange = useCallback((event, newValue) => {
        setValue(newValue);

        if(customChangeFunction){
            customChangeFunction(newValue);
        }
    }, []);

    useEffect(() => {
        setValue(manualIndex);
    }, [manualIndex]);

    return (
        <>
            <Box 
                sx={{ 
                    width: '100%'
                }}
            >
                <Tabs 
                    value={value} 
                    onChange={handleChange}
                    centered={!isMobile}
                    variant={isMobile ? "scrollable" : "standard"}
                    scrollButtons={isMobile ? "auto" : false}
                    slotProps={{
                        indicator: {
                            style: {
                                display: 'none'
                            }
                        }
                    }}
                    data-aos="slide-up"
                >
                    {
                        list.map((item, index) => {
                            return <Tab 
                                key={index}
                                label={item.label} 
                                wrapped 
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: {xs: 12, md: 14, lg: 16},
                                    lineHeight: 1.5,
                                    backgroundColor: value === index ? theme.palette.primary.main : theme.palette.background.paper,
                                    borderRadius: 8,
                                    px: 3,
                                    mx: {xs: 1, md: 2},
                                    '&.Mui-selected': {
                                        color: theme.palette.primary.contrastText
                                    },
                                    '&: hover': {
                                        transform: 'scale(0.9)'
                                    }
                                }}
                            />
                        })
                    }
                </Tabs>

                {
                    list.map((item, index) => {
                        return <TabPanel 
                            key={index}
                            value={value} 
                            index={index}
                        >
                            {item.children}
                        </TabPanel>
                    })
                }
            </Box>
        </>
    );
}

export default TabsComponent;